// extracted by mini-css-extract-plugin
module.exports = {"root":"detail-icon_root__5QM2w"};